import { FormFieldSet } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';

import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

import { payerSignatureOptions } from '../payerSignatureOptions';

export const PayerSignatureSettings = () => {
  return (
    <div className="py-2">
      <FormFieldSet
        legend="Required Signatures"
        columns={4}
        Fields={
          <>
            <div>
              <FormFieldController name="requires_signature_pickup_driver">
                {({ field }) => {
                  return (
                    <FormField
                      label="Driver on Pickup"
                      type="select"
                      inputProps={{
                        ...field,
                        id: 'requires_signature_pickup_driver',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      options={payerSignatureOptions}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
            <div>
              <FormFieldController name="requires_signature_dropoff_driver">
                {({ field }) => {
                  return (
                    <FormField
                      label="Driver on Dropoff"
                      type="select"
                      inputProps={{
                        ...field,
                        id: 'requires_signature_dropoff_driver',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      options={payerSignatureOptions}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
            <div>
              <FormFieldController name="requires_signature_pickup_passenger">
                {({ field }) => {
                  return (
                    <FormField
                      label="Passenger on Pickup"
                      type="select"
                      inputProps={{
                        ...field,
                        id: 'requires_signature_pickup_passenger',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      options={payerSignatureOptions}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
            <div>
              <FormFieldController name="requires_signature_dropoff_passenger">
                {({ field }) => {
                  return (
                    <FormField
                      label="Passenger on Dropoff"
                      type="select"
                      inputProps={{
                        ...field,
                        id: 'requires_signature_dropoff_passenger',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      options={payerSignatureOptions}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
          </>
        }
      />
    </div>
  );
};
